<template>
  <footer class="footer">
    <div class="container-fluid d-flex flex-wrap justify-content-center">
      <div class="copyright d-flex flex-wrap">
        <i class="fa fa-cubes"></i> 
        <div>
        <img src="@/assets/img/sensoreal-logo-dark.png" alt="" style="width: 60px; padding: 0 6px;">
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
export default {};
</script>
<style>
.footer .copyright {
  align-items: center;
}
</style>
